import { render, staticRenderFns } from "./updateTip.vue?vue&type=template&id=56c71a68&scoped=true&"
import script from "./updateTip.vue?vue&type=script&lang=js&"
export * from "./updateTip.vue?vue&type=script&lang=js&"
import style0 from "./updateTip.vue?vue&type=style&index=0&id=56c71a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c71a68",
  null
  
)

export default component.exports